const yup = require("yup");

// Schema for createcollegerules
const create = yup.object({
  date: yup.date().required("Date is required"),
  course: yup.string().required("Course is required"),
  name: yup.string().required("Name is required"),
});

module.exports = {
  create,
};
